module.exports = {
  PROGRAM_CONFIGURATION: 'PROGRAM_CONFIGURATION',
  BULKISSUANCE: 'BULKISSUANCE',
  MCC: 'MCC',
  ACCEPTED_COUNTRIES: 'ACCEPTED_COUNTRIES',
  CARD_PRODUCT: 'CARD_PRODUCT',
  APPLICATION_TOKEN: 'APPLICATION_TOKEN',
  ASSIGN_BIN_RANGES: 'ASSIGN_BIN_RANGES',
};
